import { AutogenLayoutEscrowTable } from "./autogen/AutogenLayoutEscrowTable";
import { OpenType } from "@mcleod/components";

export class EscrowTable extends AutogenLayoutEscrowTable {
    onLoad(): void | Promise<void> {
        this.tableEscrow.crudManager.defaultOpenType = OpenType.NEW_TAB_WITH_SWITCH;
    }
}
